import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { LegacyAntdModal } from 'components/LegacyAntdModal/LegacyAntdModal'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

import Styles from './UpdatePaymentMethodModal.module.scss'
import { REACT_APP_STRIPE_KEY } from 'env'
import { CardForm } from 'components/Paywall/UpgradePlanModal/components/PaymentForm/components/CardForm/CardForm'
import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { workspacesSet } from 'redux/actions'
import { Spinner } from 'common/Spinner/Spinner'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

export const stripePromise = loadStripe(REACT_APP_STRIPE_KEY)

interface Props {
  onClose: () => void
  onSuccess?: (card: { lastFour: number; brand: string }) => void
  onError?: () => void
}

export const UpdatePaymentMethodModal = ({ onClose, onSuccess, onError }: Props) => {
  const [isProcessing, setIsProcessing] = useState(false)
  const workspace = useCurrentWorkspace()
  const dispatch = useDispatch()
  const workspaces = useWorkspaces()

  const updatePaymentMethod = async (paymentMethodId: string) => {
    if (!workspace) return

    const res = await WorkspaceClient.updatePaymentMethod(workspace.id, paymentMethodId)
    setIsProcessing(false)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      if (res.data.success) {
        if (res.data.card) {
          if (onSuccess) {
            onSuccess({
              lastFour: res.data.card.last_four,
              brand: res.data.card.brand,
            })
          }
        }
        const updatedWorkspaces = workspaces.map((ws) => {
          if (ws.id === workspace?.id && workspace?.payment_failed) {
            return { ...workspace, payment_failed: false }
          }

          return ws
        })
        dispatch(workspacesSet(updatedWorkspaces))
        onClose()
        return
      }
      showToastMessage(res.data.message, 'error')
    }

    if (onError) onError()
  }

  return (
    <LegacyAntdModal
      visible={true}
      closable={false}
      width={'fit-content'}
      wrapClassName={Styles.antModalOverrides}
      onCancel={onClose}
    >
      <div className={Styles.headerContainer}>
        <p className={Styles.header}>Update payment details</p>
        {isProcessing && <Spinner />}
        <p className={Styles.close} onClick={onClose}>
          ✕
        </p>
      </div>
      <div className={Styles.body}>
        {isProcessing && <div className={Styles.overlay}></div>}
        <Elements stripe={stripePromise}>
          <CardForm
            isProcessing={isProcessing}
            setIsProcessing={setIsProcessing}
            onClose={onClose}
            onPaymentMethodCreated={updatePaymentMethod}
            buttonConfiguration={'stand-alone'}
          />
        </Elements>
      </div>
    </LegacyAntdModal>
  )
}
